import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { Animations } from 'src/app/animations';
import { HorizontalItemRowData, HorizontalItemRowDataGraphs, SalesUnits } from 'src/app/model/horizontal-graph';

@Component({
  selector: 'app-horizontal-more-info',
  templateUrl: './horizontal-more-info.component.html',
  styleUrls: ['./horizontal-more-info.component.scss'],
  animations: [
    Animations.openClose
  ]
})
export class HorizontalMoreInfoComponent {
  @Input() isOpen: boolean = false;
  @Input() data: HorizontalItemRowData = {} as HorizontalItemRowData;
  @Output() isOpenChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  public selectedColumn: number = -1;
  public currentUnit: keyof HorizontalItemRowDataGraphs = 'mDollar';
  public salesUnits: any = SalesUnits;

  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.initCurrentUnit();
  }

  private initCurrentUnit(): void {
    // Set selected unit
    Object.keys(this.data.graphs).forEach((key) => {
      if(this.data.graphs[key as keyof HorizontalItemRowDataGraphs]) {
        this.currentUnit = key as keyof HorizontalItemRowDataGraphs;
      }
    });

    //set default column index
    this.selectedColumn = this.data.graphs[this.currentUnit as keyof HorizontalItemRowDataGraphs].data.findIndex(column => column.isDefault);
  }

  public onSelectGarphValue(index: number): void {
    this.selectedColumn = index;
    this.cdr.detectChanges();
  }

  /**
   * Preserve original property order
   * @param a 
   * @param b 
   * @returns 
   */
  public originalOrder(a: any, b: any): number {
    return 0;
  }

  public selectUnit(key: keyof HorizontalItemRowDataGraphs): void {
    this.currentUnit = key;
  }

  public toggleMoreInfo(): void {
    this.isOpen = !this.isOpen;
    this.isOpenChange.emit(this.isOpen);
  }

}
